/**
 * Context Plugins Index
 *
 * Import all context plugins here to ensure they register themselves.
 * Adding a new context is as simple as:
 * 1. Create a new file in this directory (e.g., NewContext.jsx)
 * 2. Import it here
 *
 * The context will automatically register itself when imported.
 */

import "./UserContext";
import "./RequestContext";
import "./OutletContext";
import "./CompanyContext";
import "./ExpertContext";
import "./ProductContext";
